import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useLogout } from '@/hooks/useLogout';

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
});

function LogoutPage() {
  const logout = useLogout();
  useEffect(() => {
    logout();
  }, [logout]);
  return null;
}
